import { render, staticRenderFns } from "./PolicyScopeEmptyCell.vue?vue&type=template&id=95935574&scoped=true&"
import script from "./PolicyScopeEmptyCell.vue?vue&type=script&lang=js&"
export * from "./PolicyScopeEmptyCell.vue?vue&type=script&lang=js&"
import style0 from "./PolicyScopeEmptyCell.vue?vue&type=style&index=0&id=95935574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95935574",
  null
  
)

export default component.exports